module.exports = __webpack_public_path__ + "img/catch-thief-bg.4637ebe3.svg";